export default "__VITE_ASSET__BIvVxiTW__"